import { Box, Grid2, Typography } from "@mui/material";
import InputComponent from "components/appInput";
import CustomModalRegister from "components/concert/modalRegister";
import React, { useState } from "react";
import "./index.scss";
import { useSubmitCardNameUser } from "hooks/event";
import useInfoContext from "hooks/useInfoContext";

const ModalCardIssuanceUser = ({
  open,
  handleClose,
  step,
  setStep,
  clientInfo,
}) => {
  const [cardName, setCardName] = useState("");
  const [fontSizeCardName, setFontSizeCardName] = useState("16");
  const [cardNameError, setCardNameError] = useState("");
  const { mutate: submitCardNameUser, isLoading } = useSubmitCardNameUser();
  const { repToken, userIdRegistration } = useInfoContext();

  const handleInputChange = (value) => {
    const englishOnlyRegex = /^[a-zA-Z\s]*$/;

    let widthFactor = 30;
    let maxFontSize = 22;
    let minFontSize = 16;

    let fontSize = Math.min(
      Math.max((widthFactor / (value?.length || 1)) * 10, minFontSize),
      maxFontSize
    );
    setFontSizeCardName(fontSize);

    if (value.length > 30) {
      setCardNameError("حداکثر طول مجاز ۳۰ کاراکتر است.");
    } else if (englishOnlyRegex.test(value)) {
      setCardName(value);
      setCardNameError("");
    } else {
      setCardNameError("فقط حروف انگلیسی مجاز است.");
    }
  };

  const sendCardName = () => {
    if (cardName && repToken && userIdRegistration) {
      submitCardNameUser(
        {
          cardName: cardName,
          clientId: userIdRegistration,
          repToken: repToken,
        },
        {
          onSuccess: (response) => {
            if (response.status === "OK") {
              setStep(2);
            }
          },
        }
      );
    } else {
      console.log("Card name is invalid.");
    }
  };

  return (
    <CustomModalRegister
      open={open}
      handleClose={handleClose}
      title="افزودن همراه"
      activeStep={step + 1}
      titleBody="صدور «آن کارت» برای همراه شما"
      buttonFunction={sendCardName}
      disabledButton={!cardName}
      buttonText="تایید"
      loadingButton={isLoading}
    >
      <Grid2 item size={{ xs: 12 }} className="container-card-issuance-user">

        <Box className="card-issuance-user">
          <Box className="card-img">
            <Box
              className="name-card"
              style={{
                fontSize: `${fontSizeCardName}px`,
              }}
            >
              {cardName}
            </Box>
          </Box>
        </Box>

        <Typography variant="h6" className="description-card-issuance">
          نام و نام خانوادگی همراه خود را به صورت لاتین برای صدور «آن کارت»
          ایشان وارد کنید
        </Typography>

        <InputComponent
          type="text"
          value={cardName}
          placeholder="Sepehr Torabi :مثال"
          handleValue={handleInputChange}
          className={cardNameError ? "error" : ""}
          error={cardNameError}
          alertText={cardNameError}
        />
      </Grid2>
    </CustomModalRegister>
  );
};

export default ModalCardIssuanceUser;
